import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import DayRentalBasicRateDrawer from "components/drawer/DayRentalBasicRateDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ShowHideButton from "components/table/ShowHideButton";

const DayRentalBasicRateTable = ({
  dayRentalBasicRate,
  perpage,
  currentPage,
  hideEdit,
  hideDelete,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  const dayRentalBasicRatesorted = dayRentalBasicRate.sort((a, b) =>
   (b.city ?? "").localeCompare(a.city ?? "")
  );
  
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <DayRentalBasicRateDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {dayRentalBasicRatesorted?.slice(0, perpage).map((data, index) => (
          <React.Fragment key={data.id}>
            {data["vehicle_type_id"].map((item, vehicleIndex) => (
              <TableRow key={`${data.id}-${vehicleIndex}`}>
                {vehicleIndex === 0 && (
                  <>
                    <TableCell
                      className="text-sm text-center"
                      rowSpan={data["vehicle_type_id"].length}
                    >
                      {(currentPage - 1) * perpage + index + 1}
                    </TableCell>
                    <TableCell rowSpan={data["vehicle_type_id"].length}>
                      <span className="text-sm">{data["city"]}</span>
                    </TableCell>
                  </>
                )}
                <TableCell className="text-sm text-center">
                  {data["vehicle_type_names"][item]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["min_km"][item]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["min_rate"][item]}
                </TableCell>

                <TableCell className="text-sm text-center">
                  {data["extra_km"][item]}
                </TableCell>

                <TableCell className="text-sm text-center">
                  {data["night_allowance"][item]}
                </TableCell>
                <TableCell className="text-sm text-center">
                  {data["prime"][item] + "%"}
                </TableCell>

                
                  {vehicleIndex === 0 && (
                    <TableCell
                  className="text-center"
                  rowSpan={data["vehicle_type_id"].length}
                >
                    <ShowHideButton
                      id={data.id}
                      status={data.is_active}
                      Loading={true}
                    />
                      </TableCell>
                  )}
              

                {vehicleIndex === 0 && (
                  <TableCell
                    rowSpan={data["vehicle_type_id"].length}
                    className="text-sm text-center"
                  >
                    <EditDeleteButton
                      title={data["Day Rental"]}
                      id={data.id}
                      handleUpdate={handleUpdate}
                      handleModalOpen={handleModalOpen}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </React.Fragment>
        ))}
      </TableBody>
    </>
  );
};

export default DayRentalBasicRateTable;
